// extracted by mini-css-extract-plugin
export default {"frame":"ServiceArt_frame__oqsiw","svg":"ServiceArt_svg__bMDIZ","dark":"ServiceArt_dark__3llFe"};